import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AUTOMATION_PATH, WEBSITES_PATH } from '../routes';
import './Services.css';

const SERVICES = ['automation', 'web', 'data'];
// Services with a page of their own link to it from their card.
const SERVICE_PAGES = { automation: AUTOMATION_PATH, web: WEBSITES_PATH };

function Services() {
  const { t } = useTranslation();

  const scrollToContact = (e) => {
    e.preventDefault();
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="services" className="services">
      <p className="section-eyebrow">{t('services.eyebrow')}</p>
      <h2 className="services-title">
        <Trans i18nKey="services.heading" components={{ em: <em /> }} />
      </h2>

      <div className="services-grid">
        {SERVICES.map(key => {
          const content = (
            <>
              <h3 className="service-title">{t(`services.items.${key}.title`)}</h3>
              <p className="service-body">{t(`services.items.${key}.body`)}</p>
              <p className="service-outcome">
                <span className="service-outcome-label">{t('services.outcomeLabel')}</span>
                {t(`services.items.${key}.outcome`)}
              </p>
            </>
          );
          // A service with a page of its own is one big link to it.
          return SERVICE_PAGES[key] ? (
            <Link key={key} to={SERVICE_PAGES[key]} className="service-card service-card--link">
              {content}
              <span className="service-more">{t('servicePages.more')} →</span>
            </Link>
          ) : (
            <article key={key} className="service-card">{content}</article>
          );
        })}
      </div>

      <p className="services-lockin">{t('services.lockin')}</p>

      <a href="#contact" className="services-cta" onClick={scrollToContact}>
        {t('services.cta')}
      </a>
    </section>
  );
}

export default Services;
